<template>
  <div>
    <div>
      <div class="row">
        <div class="col-6 mb-5 mb-xl-2 col-xl-3" style="min-width: 150px">
          <div class="notifi-card baby-blue">
            <i class="far fa-clock"></i>
            <div class="title">
              <h2 v-if="eduProgram">
                {{ eduProgram.program_list.num_of_study_hours }}
              </h2>
              <b-spinner v-else type="grow" label="Loading..."  class="loading" />
              <p>ساعات الحضور</p>
            </div>
          </div>
        </div>
        <div class="col-6 mb-5 mb-xl-2 col-xl-3" style="min-width: 150px">
          <div class="notifi-card border-success">
            <i class="far fa-file"></i>
            <div class="title">
              <h2 v-if="statistics">{{ statistics.exams }}</h2>
              <b-spinner v-else type="grow" label="Loading..."  class="loading" />
              <p>اختبارات اجتيزت</p>
            </div>
          </div>
        </div>
        <div class="col-6 col-xl-3" style="min-width: 150px">
          <div class="notifi-card border-warning">
            <i class="fas fa-chalkboard-teacher"></i>
            <div class="title">
              <h2 v-if="statistics">{{ statistics.knAssessments }}</h2>
              <b-spinner v-else type="grow" label="Loading..."  class="loading" />
              <p class="text-warning">تدريبات غير مكتملة</p>
            </div>
          </div>
        </div>
        <div class="col-6 col-xl-3" style="min-width: 150px">
          <div class="notifi-card border-danger">
            <i class="fas fa-user-clock"></i>
            <div class="title">
              <h2 v-if="eduProgram">
                {{ eduProgram.program_list.num_of_direct_sessions_hours }}
              </h2>
              <b-spinner v-else type="grow" label="Loading..."  class="loading" />
              <p>ساعات الدراسة</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-card no-body>
      <b-card-header>
        <h4 class="mb-0">معدل انجاز البرنامج التعليمي</h4>
      </b-card-header>

      <!-- apex chart -->
      <vue-apex-charts
        type="radialBar"
        height="245"
        :options="goalOverviewRadialBar.chartOptions"
        :series="series"
      />
    </b-card>
  </div>
</template>

<script>
import Auth from "@/Apis/Auth";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";
import HomeController from "@/Controllers/HomeController";
export default {
  components: {
    VueApexCharts,
  },
  data() {
    return {
      goal_overview: {},
      series: [70],
      goalOverviewRadialBar: {
        chartOptions: {
          chart: {
            sparkline: {
              enabled: true,
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1,
            },
          },
          colors: ["#51e5a8"],
          plotOptions: {
            radialBar: {
              offsetY: -10,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: "77%",
              },
              track: {
                background: "#ebe9f1",
                strokeWidth: "50%",
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  color: "#5e5873",
                  fontSize: "2.86rem",
                  fontWeight: "600",
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.success],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: "round",
          },
          grid: {
            padding: {
              bottom: 30,
            },
          },
        },
      },
      eduProgram: {},
      statistics: {},
    };
  },
  async created() {
    let id = localStorage.getItem("eduProgram");
    this.eduProgram = Auth.EDU_PROGRAMS.find((a) => a.id == id);
    this.series = [this.eduProgram.completion_percentage];
    console.log(this.eduProgram.completion_percentage);
    const data = await new HomeController().StudentHome(id);

    this.statistics = data.programStatistics;
  },
};
</script>
